var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embryo-previews"},_vm._l((_vm.embryos),function(embryo,index){return _c('embryo-preview',{key:index,attrs:{"embryo":embryo}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }